import script from "./AddUser.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddUser.vue?vue&type=script&setup=true&lang=ts"

import "./AddUser.vue?vue&type=style&index=0&id=3d9a0931&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d9a0931"]])

export default __exports__